export const timesItems = Array.from({ length: 60 }, (_, i) => {
  const minute = i.toString().padStart(2, "0");
  return {
    label: minute + "",
    value: minute,
  };
});

export const hoursItems = Array.from({ length: 24 }, (_, i) => {
  const hour = i.toString().padStart(2, "0");
  return {
    label: hour + "",
    value: hour + "",
  };
});
